export default "__VITE_ASSET__BQe65qX5__"